import { getTaxFreeAmountName } from '@/app/common/converters/contract/taxFreeAmountToTextConverter'
import { getContractTypeName } from '@/app/common/converters/contractTypeToTextConverter'
import { getDriverQualificationTypeName } from '@/app/common/converters/driverQualificationToTextConverter'
import { getNettoRateTypeName } from '@/app/common/converters/nettoRateTypeTextConverter'
import { getRatesOptionName } from '@/app/common/converters/ratesOptionToTextConverter'
import { getSettlementTypeName } from '@/app/common/converters/settlementTypeToTextConverter'
import { ContractType } from '@/app/constants/contractType'
import {
  QUALIFICATION_TYPES_AUSTRIA,
  QUALIFICATION_TYPES_BELGIUM,
  QUALIFICATION_TYPES_CZECH,
  QUALIFICATION_TYPES_DENMARK,
  QUALIFICATION_TYPES_FINLAND,
  QUALIFICATION_TYPES_FRANCE,
  QUALIFICATION_TYPES_ITALY,
  QUALIFICATION_TYPES_LUKSEMBOURG,
} from '@/modules/drivers/constants/qualifications'
import {
  NettoRateType,
  RatesOption,
  SettlementType,
  TaxFreeAmount,
} from '@/modules/drivers/types/contracts'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

import {
  BONUS_RATES_OPTIONS,
  DUTY_RATES_OPTIONS,
  NIGHT_RATES_OPTIONS,
  REWARD_RATES_OPTIONS,
} from '@/modules/drivers/constants/rates'
import { AdditionForLaundryType } from '@/app/constants/additionForLaundryType'
import { getAdditionForLaundryTypeName } from '@/app/common/converters/contract/additionForLaundryTypeToTextConverter'

const useContractFieldSetOptions = () => {
  const { t } = useLocalize()

  const contractTypeOptions = Object.values(ContractType).map((ct) => ({
    value: ct,
    label: getContractTypeName(ct, t),
  }))
  const contractSettlementOptions = Object.values(SettlementType).map((ct) => ({
    value: ct,
    label: getSettlementTypeName(ct, t),
  }))

  const contractNettoOptions = Object.values(NettoRateType)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct.toString(),
      label: getNettoRateTypeName(ct, t),
    }))

  const contractTaxesFreeOptions = Object.values(TaxFreeAmount)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct.toString(),
      label: getTaxFreeAmountName(ct, t),
    }))

  const contractQualificationAustriaOptions = Object.values(
    QUALIFICATION_TYPES_AUSTRIA,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationLuksemburgOptions = Object.values(
    QUALIFICATION_TYPES_LUKSEMBOURG,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationItalyOptions = Object.values(
    QUALIFICATION_TYPES_ITALY,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationBelgiumOptions = Object.values(
    QUALIFICATION_TYPES_BELGIUM,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationCzechOptions = Object.values(
    QUALIFICATION_TYPES_CZECH,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationDenmarkOptions = Object.values(
    QUALIFICATION_TYPES_DENMARK,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationFranceOptions = Object.values(
    QUALIFICATION_TYPES_FRANCE,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))
  const contractQualificationFinlandOptions = Object.values(
    QUALIFICATION_TYPES_FINLAND,
  ).map((ct) => ({
    value: ct,
    label: getDriverQualificationTypeName(ct, t),
  }))

  const contractRatesOptions = Object.values(DUTY_RATES_OPTIONS)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct.toString(),
      label: getRatesOptionName(ct, t),
    }))

  const contractNightOptions = Object.values(NIGHT_RATES_OPTIONS).map((ct) => ({
    value: ct.toString(),
    label: getRatesOptionName(ct, t),
  }))
  const contractDutyOptions = Object.values(NIGHT_RATES_OPTIONS).map((ct) => ({
    value: ct.toString(),
    label: getRatesOptionName(ct, t),
  }))
  const contractBonusOptions = Object.values(BONUS_RATES_OPTIONS).map((ct) => ({
    value: ct.toString(),
    label: getRatesOptionName(ct, t),
  }))
  const contractRewardOptions = Object.values(REWARD_RATES_OPTIONS).map(
    (ct) => ({
      value: ct.toString(),
      label: getRatesOptionName(ct, t),
    }),
  )

  const contractLaundryOptions = Object.values(AdditionForLaundryType)
    .filter((v) => typeof v === 'number')
    .map((ct) => ({
      value: ct.toString(),
      label: getAdditionForLaundryTypeName(ct, t),
    }))
  return {
    // Rates
    contractNightOptions,
    contractDutyOptions,
    contractBonusOptions,
    contractRewardOptions,
    contractRatesOptions,

    //   contractQualificationAustriaOptions,
    contractQualificationLuksemburgOptions,
    contractQualificationFinlandOptions,
    contractQualificationBelgiumOptions,
    contractQualificationCzechOptions,
    contractQualificationDenmarkOptions,
    contractQualificationItalyOptions,
    contractQualificationFranceOptions,
    contractQualificationAustriaOptions,

    // Other
    contractLaundryOptions,
    contractTaxesFreeOptions,
    contractTypeOptions,
    contractSettlementOptions,
    contractNettoOptions,
  }
}

export default useContractFieldSetOptions
